/* * @Author: Wei Guojun * @Date: 2021-05-31 11:06:35 * @Last Modified by: Wei
Guojun * @Last Modified time: 2022-02-10 14:41:02 */
<template>
  <div>
    <div class="form">
      <div class="itemView" style="font-size: 12px;cursor: pointer;float:left" @click="goerrorTip('XXXXXX')" v-if="$store.state.teamModel=='2'">
         <span style="line-height: 40px; color: red; padding-left: 10px;">*</span>
         <span >
        团队共享地址仅允许团员本人修改和删除，其他团员仅可使用或复制</span>
        
       <i class="el-icon-question " style="color: #409EFF;"></i></div>
       <div>
        <el-input
          v-model.trim="keyword"
          placeholder="请输入姓名、手机号等进行搜索"
          clearable
          style="width: 400px"
          size="small"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 30px"
          @click="searchData"
          >查询</el-button
        >
       </div>
    </div>
    <div class="tableCurd">
      <div class="export">
        <label>
          共
          <span class="total">{{ total }}</span
          >条记录符合：
        </label>
        <div class="btngroups">
          <el-button type="primary" size="small" @click="addCollect"
            >新增寄件人信息</el-button
          >
          <el-button
            type="text"
            size="small"
            style="padding: 9px 20px"
            @click="isImport = true"
            >导入</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        size="mini"
        :height="tableHeight"
        id="tableBox"
      >
        <el-table-column align="center" width="50" label="选择">
          <template slot-scope="scope">
            <el-checkbox
              :value="parcel_id_list.includes(scope.row.id)"
              @change="checkBox(scope.row.id)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="姓名" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          align="center"
          label="手机"
          width="200"
        ></el-table-column>
        <el-table-column prop="city" align="left" label="寄件地址">
          <template slot-scope="scope">
            <el-tag v-if='scope.row.account_id != account_id' size="mini">共享地址</el-tag>
            <el-tag v-if='scope.row.account_id == account_id&&scope.row.address_type == 2' size="mini">默认</el-tag>
            {{ scope.row.province_name }} {{ scope.row.city_name }}
            {{ scope.row.district_name }} {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.address_type != 2"
              type="text"
              size="small"
              :disabled="scope.row.account_id != account_id"
              @click="setDefault(scope.row, 2)"
              >设为默认</el-button
            >
            <el-button
              v-else
              type="text"
              size="small"
              :disabled="scope.row.account_id != account_id"
              @click="setDefault(scope.row, 1)"
              >取消默认</el-button
            >
            <el-button type="text" size="small" :disabled="scope.row.account_id != account_id"  @click="editRow(scope.row)"
              >编 辑</el-button
            >
            <el-button type="text" size="small" :disabled="scope.row.account_id != account_id" @click="delRow(scope.row)"
              >删 除</el-button
            >
          </template>
        </el-table-column>
        <div slot="empty" class="noBody" v-if="haveData">
          <img src="@/assets/images/nodata.png" alt="" />
        </div>
      </el-table>
    </div>
    <div class="pages">
      <div class="pages_left"></div>
      <div class="pages_right">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          :page-size="page_size"
          @size-change="changeSizes"
          :current-page.sync="currentPage"
          :page-sizes="[30, 50, 100]"
          @current-change="currentPageFun"
          layout="sizes,prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        <div slot="append" class="sure" type="primary">确定</div>
      </div>
    </div>
    <footer>
      <div class="footer">
        <div>
          <div class="allCheck">
            <el-checkbox @change="allCheck" v-model="all">本页全选</el-checkbox>
            <span
              >已选<b>{{ parcel_id_list.length }}</b></span
            >
          </div>
          <div class="btnGroup">
            <el-button
              type="primary"
              class="btn"
              @click="batchDel()"
              href="javascript:void(0)"
              >批量删除</el-button
            >
          </div>
        </div>
      </div>
    </footer>
    <div v-if="collectShow">
      <el-dialog
        top="180px"
        :title="title"
        :visible.sync="collectShow"
        width="1000px"
        center
      >
        <div>
          <editAddress :editObj="editObj" :addOredit="addOredit"></editAddress>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="750px"
      height="240px"
      top="15%"
      :visible.sync="isImport"
      center
    >
      <div slot="title"></div>
      <div class="model">
        <div class="content">
          <div class="c_title">导入寄件人:</div>
          <div class="tips">
            <span>*</span
            >文件大小大可超过1MB,模板中“<span>*</span>”为必填项<br />
            <el-link :href="downloadFileUrl" :underline="true" type="primary"
              >下载标准模板</el-link
            >进行导入,或者直接使用风火递、快递100导出的收、寄件人进行导入;<br />
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button
          type="primary"
          plain
          style="margin-right: 50px"
          @click="isImport = false"
          >取消</el-button
        >
        <el-upload
          action=""
          ref="excel-upload-input"
          class="upload-demo"
          :multiple="false"
          accept=".xlsx, .xls"
          :before-upload="beforeUpload"
          :http-request="uploadAction"
        >
          <el-button :loading="isUp" type="primary">确定导入</el-button>
        </el-upload>
      </span>
    </el-dialog>
    <el-dialog title="智能粘贴" :visible.sync="moreVisble" width="600px" center>
      <span>粘贴说明：智能粘贴多条地址间用换行符隔开，最多支持10条地址</span>
      <div class="forExample">
        <div class="left">例如：</div>
        <div class="right">
          韵达大碗面 13118954372 上海市上海市青浦区盈港东路6679号<br />
          陈静怡 13150456588 云南省丽江市古城区金山白族乡丽江师范高等专科学校
        </div>
      </div>
      <el-input
        type="textarea"
        placeholder="请输入粘贴内容"
        v-model.trim="copyText"
        show-word-limit
      >
      </el-input>
      <div class="flexEnd">
        <el-button size="mini" type="primary" @click="jxBtnfun(copyText)"
          >解析</el-button
        >
      </div>
      <div class="cp_title">
        已识别{{ rightNum }}可用地址信息，{{
          errorNum
        }}个异常地址可在上方输入框中修改地址信息,<span>重新点击【解析】</span>
      </div>
      <ul>
        <li v-for="(item, index) in anslsList" :key="index" class="ListItem">
          <span v-if="item.name_error" class="errorTip">{{
            item.name || "缺少姓名"
          }}</span>
          <span v-else>{{ item.name }}</span>
          <span v-if="item.phone_error" class="errorTip">{{
            item.phone || "缺少联系方式"
          }}</span>
          <span v-else>{{ item.phone }}</span>
          <span v-if="item.address_error" class="errorTip"
            >{{ item.province_name || "缺少省名称"
            }}{{ item.city_name || "缺少市名称"
            }}{{ item.district_name || "缺少区名称" }}{{ item.address }}</span
          >
          <span v-else
            >{{ item.province_name }}{{ item.city_name }}{{ item.district_name
            }}{{ item.address }}</span
          >
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureUse" size="mini"
          >确定使用({{ rightNum }})</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editAddress from "@/components/editAddress";
import home from "@/api/home";
import util from "@/util/util";
export default {
  name: "sendMenu",
  data() {
    return {
      tableHeight: 300,
      keyword: "",
      tableData: [],
      currentPage: 1,
      page_size: 30,
      total: 0,
      loading: false,
      parcel_id_list: [],
      all: false,
      haveData: false,
      title: "",
      collectShow: false,
      editObj: {},
      addOredit: {
        type: "",
        name: "寄件人",
      },
      isImport: false,
      downloadFileUrl: "",
      isUp: false,
      moreVisble: false,
      anslsList: [],
      errorNum: 0,
      rightNum: 0,
      rightArr: [],
      copyText: "",
      account_id: util.getCookie("account_id")
    };
  },
  components: {
    editAddress,
  },
  created() {
    this.loadmore(this.currentPage);
    this.downloadFileUrl =
      util.getJsonValues(this.$store.state.commondict, "addressexcell") ||
      "https://kdyduat.jxnq.net/address.xls";
  },
  mounted() {
    util.getTableHeight(this, document.getElementById("tableBox"), 104);
    window.addEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  methods: {
    goerrorTip(){
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct){
        const Item = JSON.parse(Obstruct).teamAddress
        window.open(Item)
      }
    },
    /** 解析绑定地址 */
    jxBtnfun(analysis) {
      let self = this;
      if (!analysis) {
        self.$message({
          type: "warning",
          message: "请填写解析内容",
        });
        return;
      }
      home.doAnalysis(self, analysis).then((res) => {
        if (res.success) {
          if (res.data.length > 1) {
            self.anslsList = res.data;
            self.fitInit();
          }
        }
      });
    },
    //确定使用
    sureUse() {
      const rightArr = this.rightArr;
      for (let i = 0, len = rightArr.length; i < len; i++) {
        this.newCreatAddress(rightArr[i], 1);
      }
      this.moreVisble = false;
      this.$message.success("寄件人地址保存成功");
      this.currentPage = 1;
      this.loadmore(this.currentPage);
    },
    //新增联系人
    newCreatAddress(obj, type) {
      let data = {
        account_id: util.getCookie("account_id"),
        address: obj.address,
        city_code: obj.city_code,
        district_code: obj.district_code,
        name: obj.name,
        phone: obj.phone,
        province_code: obj.province_code,
        address_type: type,
      };
      home.createAddress(this, data).then((res) => {
        if (res.success) {
          console.log(res);
        } else {
          console.log(res);
        }
      });
    },
    //数组筛选
    fitInit() {
      let rightArr = [];
      const anslsList = this.anslsList;
      for (let i = 0, len = anslsList.length; i < len; i++) {
        if (
          !anslsList[i].name_error &&
          !anslsList[i].phone_error &&
          !anslsList[i].address_error
        ) {
          rightArr.push({
            address: anslsList[i].address,
            city_code: anslsList[i].city_code,
            city_name: anslsList[i].city_name,
            district_code: anslsList[i].district_code,
            district_name: anslsList[i].district_name,
            name: anslsList[i].name,
            phone: anslsList[i].phone,
            province_code: anslsList[i].province_code,
            province_name: anslsList[i].province_name,
          });
        }
      }
      this.rightArr = rightArr;
      this.errorNum = this.anslsList.length - rightArr.length;
      this.rightNum = rightArr.length;
    },
    //上传之前
    beforeUpload(file) {
      this.files = file;
      this.isUp = true;
      let fileSize = file.size / 1024;
      if (fileSize > 1024) {
        this.$message.error("您上传的文件大小超过1MB，请调整后重新上传！");
        this.isUp = false;
        this.isImport = false;
        return false;
      }
      return true;
    },
    //上传动作
    uploadAction() {
      let formData = new FormData();
      formData.append("account_id", util.getCookie("account_id"));
      formData.append("file", this.files);
      formData.append("address_type", 1);
      home
        .upLoadaddress(this, formData, "/file/addressexcelimport")
        .then((res) => {
          if (res.success) {
            this.$message.success(
              "导入成功，任务已加入队列，请稍后刷新列表查看!"
            );
            this.isImport = false;
            this.isUp = false;
          }
        })
        .finally(() => {
          this.isUp = false;
        });
    },
    //搜索
    searchData() {
      this.currentPage = 1;
      this.loadmore(this.currentPage);
    },
    //新增收件人
    addCollect() {
      this.title = "新增寄件人信息";
      this.collectShow = true;
      this.editObj = {};
      this.addOredit.type = "add";
    },
    /** 改变条数 */
    changeSizes(e) {
      this.page_size = e;
      this.currPage = 1;
      this.loadmore(this.currentPage);
    },
    /** 当前页 */
    currentPageFun(e) {
      this.currentPage = e;
      this.loadmore(e);
    },
    loadmore(currentPage) {
      let self = this;
      self.all = false;
      self.parcel_id_list = [];
      self.loading = true;
      home
        .getAddressList(self, 1, currentPage ? currentPage : this.currentPage)
        .then((res) => {
          if (res.success) {
            self.total = res.data.total;
            self.tableData = res.data.list;
            self.loading = false;
            if (res.data.list.length > 0) {
              this.haveData = false;
            } else {
              this.haveData = true;
            }
          } else {
            self.loading = false;
          }
        });
    },
    handleCurrentChange(val) {
      this.getTableList(val);
    },
    /** 单选单个Box */
    checkBox(e) {
      let list = this.parcel_id_list;
      if (list.indexOf(e) != -1) {
        list.splice(
          list.findIndex((item) => item === e),
          1
        );
      } else {
        list.push(e);
      }
      if (list.length > 0 && list.length < this.tableData.length) {
        this.isAll = true;
        this.all = false;
      } else if (list.length == this.tableData.length) {
        this.isAll = false;
        this.all = true;
      } else {
        this.isAll = false;
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    /** 全选 */
    allCheck(e) {
      let list = [];
      if (e) {
        this.tableData.forEach((item) => {
          list = [...list, item.id];
        });
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    //设置/取消默认
    setDefault(item, type) {
      const listType = item.address_type;
      this.$confirm(
        listType == 1
          ? "确定此寄件人设为默认寄件人吗?"
          : "取消后,创建订单将无默认寄件人信息!",
        "提示",
        {
          confirmButtonText: listType == 1 ? "确定设置" : "确定取消",
          cancelButtonText: "再考虑下",
          type: "warning",
        }
      )
        .then(() => {
          let data = {
            account_id: util.getCookie("account_id"),
            address_type: type,
            name: item.name,
            phone: item.phone,
            id: item.id,
            city_code: item.city_code,
            district_code: item.district_code,
            province_code: item.province_code,
            address: item.address,
          };
          home.updateAddress(this, data).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "操作成功!" });
              this.currentPage = 1;
              this.loadmore(this.currentPage);
            }
          });
        })
        .catch(() => {});
    },
    //单个删除
    delRow(item) {
      this.$confirm(
        item.address_type == 2
          ? "此寄件人信息为默认寄件信息，确定删除吗?"
          : "确定删除此寄件人信息吗?",
        "提示",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "再考虑下",
          type: "warning",
        }
      )
        .then(() => {
          home.delAddress(this, item.id).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "删除成功!" });
              this.currentPage = 1;
              this.loadmore(this.currentPage);
            }
          });
        })
        .catch(() => {});
    },
    //批量删除
    batchDel() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要删除的寄件人",
        });
        return;
      }
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个寄件人，确认删除已选寄件人信息？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        home.alldelAddress(this, this.parcel_id_list).then((res) => {
          if (res.success) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.parcel_id_list = [];
            this.all = false;
            this.loadmore();
          }
        });
      });
    },
    //编辑
    editRow(item) {
      this.title = "编辑寄件人信息";
      this.collectShow = true;
      this.addOredit.type = "edit";
      this.editObj = item;
    },
  },
};
</script>
<style lang="stylus" scoped>
.form{
    padding: 20px 40px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
}
.tableCurd{
    padding 0 40px 20px 40px;
    .export{
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      line-height: 32px;
      font-size:14px;
      label {
        color: #666666;
        .total {
            color: #409EFF;
        }
      }
    }
}
.noBody {
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    img {
        width: 255px;
        height: 255px;
    }

    p {
        margin-top: 30px;
    }
}
.pages {
    display: flex;
    justify-content: space-between;
    // padding: 0px 40px 80px 40px;

    .pages_right {
     display: flex;

    .sure {
        display: inline-block;
        width: 48px;
        height: 28px;
        margin: 0 5px;
        font-size: 12px;
        text-align: center;
        line-height: 28px;
        border-radius: 4px;
        border: 1px solid rgba(220, 220, 220, 1);
        cursor: pointer;
    }

    .sure:hover {
        background: #2288f8;
        border: 1px solid #2288f8;
        color: #fff;
    }
    }

    /deep/ .el-pager .number {
    border: 1px solid #DCDCDC;
    color: #666666;
    font-size: 14px;
    margin: 0 5px;
    height: 30px;
    min-width: 30px;
    border-radius: 5px;

    &:hover {
        background: rgba(0, 0, 0, 0.2);
        color: #ffffff;
    }
    }

    /deep/ .el-pager .active {
    transition: all 0.3s;
    background: #2288F8;
    border: 1px solid #2288F8;
    color: #ffffff;

    &:hover {
        background: #2288F8;
        border: 1px solid #2288F8;
        color: #ffffff;
    }
    }

    /deep/ .btn-prev, /deep/.btn-next {
    border: 1px solid #DCDCDC;
    color: #666666;
    font-size: 14px;
    padding: 0 6px;
    min-width: 60px;
    height: 30px;
    border-radius: 5px;

    &:hover {
        background: #2288F8;
        border: 1px solid #2288F8;
        color: #ffffff;
    }
    }
}
footer {
    height: 40px;
    position: fixed;
    z-index: 99;
    left: 0;
    bottom: 0;
    right: 0;

    .footer {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      text-align: center;
      box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
      padding-left: 60px;


      >div {
        width: 1200px;
        margin: 0 auto;
        text-align: center;

        .allCheck {
          float: left;
          span{
           padding-left:10px
           b{
            padding:0 5px;
            color:#1c8bf6
           }
          }
        }
        .btnGroup{
          width : 100%
        }
        .btn {
          width 160px;
          margin-right 50px;
          padding 8px 10px;
        }
      }
    }
  }
.model {
    padding: 0 40px;
    font-weight: normal;

    .title {
        color: #212121;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }

    .content {
        text-align: left;
        line-height 30px;
        font-size 14px
        letter-spacing :2px
        .c_title{
        font-size:16px
        }
    }

    .dowbload {
        padding: 15px 0;

        a {
        border: 1px solid #1C8BF6;
        padding: 6px 15px;
        border-radius: 4px;
        }
    }

    span {
        color: #FF0000;
    }
    /deep/ .el-dialog__body {
            padding: 10px 40px;
    }
}
.upload-demo /deep/ .el-upload-list{
    display none;
}
  .forExample{
    display: flex;
    justify-content: flex-start;
    padding: 10px 0;
    font-size: 12px;
    color: #909399;
    .left{
      width 40px
      text-align left
    }
    .right{
      flex 1
    }
  }
  .cp_title{
    padding 10px 0;
    color #E6A23C;
    span{
      color #F56C6C
    }
  }
  .errorTip{
    color:#F56C6C
  }
  .ListItem span{
    padding-right:5px;
  }
  .flexEnd{
    padding-top 10px;
    display flex;
    justify-content: flex-end
  }
</style>
